import { atom } from 'jotai'
import {
  CustomerType,
  ExistingCustomerFormData,
  NewCustomerFormData,
  newCustomerValidationAtom,
  reviewCustomerAtom,
  reviewCustomerStepValidationAtom
} from './reviewCustomer.primitives.atoms'
import { required, validateField } from '@sequencehq/utils/validation'

export const customerTypeAtom = atom(
  get => {
    const stepData = get(reviewCustomerAtom)
    return stepData.customerType
  },
  (_get, set, newType: CustomerType) => {
    set(reviewCustomerAtom, {
      customerType: newType
    })
  }
)

export const newCustomerAtom = atom(
  get => {
    const stepData = get(reviewCustomerAtom)
    return stepData.newCustomer
  },
  (get, set, newData: Partial<NewCustomerFormData>) => {
    const existingStepData = get(reviewCustomerAtom)
    set(reviewCustomerAtom, {
      newCustomer: {
        ...existingStepData.newCustomer,
        ...newData
      }
    })
  }
)

export const existingCustomerAtom = atom(
  get => {
    const stepData = get(reviewCustomerAtom)
    return stepData.existingCustomer
  },
  (get, set, newData: Partial<ExistingCustomerFormData>) => {
    const existingStepData = get(reviewCustomerAtom)
    set(reviewCustomerAtom, {
      existingCustomer: {
        ...existingStepData.existingCustomer,
        ...newData
      }
    })
  }
)

export const existingCustomerValidationAtom = atom(get => {
  const existingCustomer = get(existingCustomerAtom)
  return {
    id: validateField(existingCustomer.id)([required])
  }
})

export const isExistingCustomerValidAtom = atom(get => {
  const validationState = get(existingCustomerValidationAtom)
  return Object.values(validationState).every(errors => errors.length === 0)
})

export const currentFormIsInvalidAtom = atom(get => {
  const newCustomerValidation = get(newCustomerValidationAtom)
  const isExistingCustomerValid = get(isExistingCustomerValidAtom)
  const customerType = get(customerTypeAtom)

  if (customerType === 'new') {
    return !newCustomerValidation.isValid
  }

  return !isExistingCustomerValid
})

export const showValidationErrorsAtom = atom(
  get => {
    const { showValidationErrors } = get(reviewCustomerStepValidationAtom)
    return showValidationErrors
  },
  (_get, set, show: boolean) => {
    set(reviewCustomerStepValidationAtom, {
      showValidationErrors: show
    })
  }
)
